import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { forwardRef, memo } from 'react'
import { cn } from 'utils/cn'

export const Separator = memo(
    forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>(
        ({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
            <SeparatorPrimitive.Root
                ref={ref}
                decorative={decorative}
                orientation={orientation}
                className={cn(
                    'bg-border shrink-0',
                    orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
                    className,
                )}
                {...props}
            />
        ),
    ),
)
Separator.displayName = SeparatorPrimitive.Root.displayName
